var map = {
	"./-1.svg": "9318",
	"./-2.svg": "5768",
	"./-7.svg": "3b8b",
	"./-8.svg": "6a54",
	"./10.svg": "decc",
	"./11.svg": "f3e6",
	"./12.svg": "0c95",
	"./13.svg": "02ca",
	"./14.svg": "d38cf",
	"./15.svg": "7faa",
	"./16.svg": "70b1",
	"./17.svg": "82d5",
	"./18.svg": "abc2",
	"./19.svg": "bf70",
	"./2.svg": "13ec",
	"./20.svg": "7624",
	"./21.svg": "36ed",
	"./22.svg": "7401",
	"./25.svg": "8a9f",
	"./26.svg": "080c",
	"./27.svg": "e932",
	"./28.svg": "67d0",
	"./29.svg": "6afc",
	"./3.svg": "ee9b",
	"./30.svg": "0b1f",
	"./32.svg": "466d",
	"./33.svg": "39a6",
	"./34.svg": "224b",
	"./35.svg": "8fac",
	"./36.svg": "fe91",
	"./37.svg": "2035",
	"./40.svg": "b711",
	"./41.svg": "a4ef",
	"./42.svg": "03c6",
	"./43.svg": "579d",
	"./44.svg": "2bb0",
	"./45.svg": "8c84",
	"./46.svg": "282f",
	"./47.svg": "0729",
	"./48.svg": "7c77",
	"./49.svg": "4cb5",
	"./50.svg": "a727",
	"./51.svg": "ae80",
	"./7.svg": "520d",
	"./9.svg": "8774",
	"./start.svg": "592a",
	"./stop.svg": "d6c64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba85";